<template>
  <div class="flex-box">
    <v-head></v-head>
    <v-sidebar v-if="leftmenu"></v-sidebar>
    <div class="content-box" :class="{'content-collapse':collapse}"  v-if="leftmenu">
      <router-view></router-view>
    </div>
    <div class="content-boxm" :class="{'content-collapse':collapse}"  v-else>
      <router-view></router-view>
    </div>
    <v-foot></v-foot>
  </div>
</template>

<script>
import vHead from './Header.vue'
import vSidebar from './Sidebar.vue'
import vFoot from './Footer.vue'
import dashboard from '../page/Dashboard.vue'
import order from '../page/Order.vue'
import faPiao from '../page/FaPiao.vue'
import user from '../page/User.vue'

import bus from './bus'
export default {
  data() {
    return {
      tagsList: [],
      collapse: false,
      leftmenu: false
    }
  },
  components: {
    vHead,
    vFoot,
    vSidebar,
    dashboard,
    order,
    faPiao,
    user
  },
  watch: {
    $route(route) {
      // 订单加载菜单
      this.initRoute()
    }
  },
  created() {
    // 订单加载菜单
    this.initRoute()
    // --开始
    bus.$on('collapse', msg => {
      this.collapse = msg
    })
    // 只有在标签页列表里的页面才使用keep-alive，即关闭标签之后就不保存到内存中了。
    bus.$on('tags', msg => {
      let arr = []
      for (let i = 0, len = msg.length; i < len; i++) {
        msg[i].name && arr.push(msg[i].name)
      }
      this.tagsList = arr
    })
  },
  methods: {
    initRoute() {
      if (
        this.$route.path.startsWith('/order') ||
        this.$route.path.startsWith('/gongchengkuan') ||
        this.$route.path.startsWith('/hetonglvyue') ||
        this.$route.path.startsWith('/nongmingong') ||
        this.$route.path.startsWith('/yufukuan')
      ) {
        this.leftmenu = true
      } else {
        this.leftmenu = false
      }
    }
  }
}
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/common/Home.vue